import en from './en'
import nl from './nl'

export type Translations = typeof en

export default {
	en,
	nl,
}
